import './App.css';
import './index.css';
import React from "react";
import {BrowserRouter, Routes, Route} from "react-router-dom";
import Header from "./Components/Header/Header";
import Home from "./Pages/Home";
import UseCases from "./Pages/UseCases";
import TermsAndCondition from "./Components/EssentialPages/TermsAndConditions/TermsAndCondition";
import PrivacyPolicy from "./Components/EssentialPages/PrivacyPolicy/PrivacyPolicy";
import Company from "./Pages/Company";
import Footer from "./Components/Footer/Footer";
import PricingPlan from "./Pages/PricingPlan";
import ErrorPages from "./Components/EssentialPages/ErrorPages/ErrorPages";
import Blog from "./Pages/Blog";
import BlogDetails from "./Pages/BlogDetails";
import UseCaseDetail from "./Pages/UseCaseDetails";
import {UseCaseList} from "./Components/Contents/UseCaseList";
import Security from "./Pages/Security";
import RequestAccess from "./Pages/RequestAccess";

export default class App extends React.Component {
    constructor(props) {
        super(props);
        this.scrollRef = React.createRef();
        this.state = {
            headerColor: "transparent",
            articleID: "",
            useCaseID: "",
            pageType: ""
        }
    }

    componentDidMount() {
        this.checkURL();
    }

    checkURL = () => {

        let currentURL = window.location.href;
        let urlArray = currentURL.split("/");
        let lastURL = urlArray[urlArray.length - 1];
        let useCaseLinks = Object.keys(UseCaseList);

        if (urlArray[urlArray.length - 2] === "blog") {
            this.setState({
                articleID: lastURL,
                useCaseID: '',
                pageType: "blog"
            })
        }


        else  if (useCaseLinks.includes(lastURL)) {
            this.setState({
                useCaseID: lastURL,
                articleID: '',

                pageType: "usecase detail"
            })

        }

        else if(lastURL === "pricing"){
            this.setState({
                pageType: "pricing",
                articleID: '',
                useCaseID: '',
            })
        }
        else {
           this.setState({
               articleID: '',
               useCaseID: '',
               pageType: "default"
           })
        }
    }

    setArticleID = (id) =>{
        this.setState({
            articleID: id
        })
    }
    setUseCaseID = (id) =>{
        this.setState({
            useCaseID: id
        })
    }

    onScrollHandler = () => {
        if (this.scrollRef.current) {
            const {scrollTop} = this.scrollRef.current;
            if (scrollTop === 0 && this.state.headerColor === "#09092df0") {
                this.setState({
                    headerColor: "transparent"
                })
            } else if (this.state.headerColor === "transparent") {
                this.setState({
                    headerColor: "#212E33f0"
                })
            }
        }

    };

    scrollToTop = () =>{

        if (this.scrollRef.current) {
            this.scrollRef.current.scrollTo({
                top: 0,
                behavior: 'instant',

            });
        }


    }


    resetInfo = () => {
        this.setState({
            articleID: '',
            useCaseID: '',
        })
        this.resetPage();
    }

    resetPage = () =>{
        this.setState({
            pageType: "default"
        })
    }
    openDetailPage = () =>{
        this.setState({
            pageType: "usecase detail"
        })
    }

    render() {
        let {articleID, useCaseID, pageType} = this.state;
        return (
            <div className="main-layout"
                 ref={this.scrollRef}
                 onScroll={this.onScrollHandler.bind(this)}>
                <BrowserRouter>
                    <Header backgroundColor={this.state.headerColor} resetInfo={this.resetInfo.bind(this)}  scrollToTop={this.scrollToTop.bind(this)}/>
                    <div className={this.state.pageType === "usecase detail"? "main-body full-screen": pageType === "pricing"? "main-body pricing":"main-body"}>
                        <Routes>
                            {
                                this.state.articleID !== undefined && this.state.articleID !== null && this.state.articleID !== ''?
                                    <Route path={"/blog/" + articleID}
                                           element={<BlogDetails articleID={articleID}
                                                                 setArticleID={this.setArticleID.bind(this)} scrollToTop={this.scrollToTop.bind(this)}/>}
                                           exact/>
                                           :
                                this.state.useCaseID !== undefined && this.state.useCaseID !== null && this.state.useCaseID !== ''?
                                    <Route path={"/" + useCaseID}
                                           element={<UseCaseDetail
                                               checkURL={this.checkURL.bind(this)}
                                               resetPage={this.resetPage.bind(this)}
                                               useCaseID={useCaseID}
                                               resetInfo={this.resetInfo.bind(this)}/>}
                                           exact/>
                                           :
                                    <Route path="/*" element={<ErrorPages/>}/>
                            }
                            <Route path="/" element={<Home  openDetailPage={this.openDetailPage.bind(this)}
                                                            setUseCaseID={this.setUseCaseID.bind(this)}
                                                            scrollToTop={this.scrollToTop.bind(this)} />}/>
                            <Route path="/home" element={<Home  openDetailPage={this.openDetailPage.bind(this)}
                                                                setUseCaseID={this.setUseCaseID.bind(this)}
                                                                scrollToTop={this.scrollToTop.bind(this)}/>}/>
                            <Route path="/security" element={<Security/>}/>
                            <Route path="/ai-ip-use-cases" element={<UseCases type={"ai-ip-use-cases"}
                                                                              openDetailPage={this.openDetailPage.bind(this)}
                                                                       setUseCaseID={this.setUseCaseID.bind(this)}
                                                                       scrollToTop={this.scrollToTop.bind(this)}/>}/>
                            <Route path="/pricing" element={<PricingPlan/>}/>
                            <Route path="/terms-and-conditions" element={<TermsAndCondition/>}/>
                            <Route path="/privacy-policy" element={<PrivacyPolicy/>}/>
                            <Route path="/blogs" element={<Blog setArticleID={this.setArticleID.bind(this)} scrollToTop={this.scrollToTop.bind(this)}/>}/>
                            <Route path="/company" element={<Company/>}/>
                            <Route path="/request_early_access" element={<RequestAccess/>}/>



                        </Routes>
                    </div>

                    <Footer scrollToTop={this.scrollToTop.bind(this)}/>

                </BrowserRouter>
            </div>

        );
    }
}
